import { PickerDropdown } from './Dropdown.jsx'
import { TIME_OFF_REASONS, REQUEST_STATUSES } from '../../../shared/timeoff.js'

/**
 * Why somebody is away, whether their request is in, and a private note (migration 025).
 *
 * One component for both time-off dialogs, so booking one person off and booking five off
 * ask the same three questions the same way. Fenced off under its own heading because
 * everything else in those dialogs is what the crew will see on the board, and these are the
 * three things they will not; saying so where the choice is made is what keeps somebody from
 * typing "sick" into the public note out of habit.
 *
 * `value` is { reason, requestStatus, internalNote }, blanks as ''. `onChange` gets a patch.
 */
export default function TimeOffPrivateFields({ value, onChange, idPrefix = 'to' }) {
  return (
    <fieldset className="to-private">
      <legend>
        For schedulers <span className="hint">field staff never see these</span>
      </legend>
      <div className="to-private-row">
        <div className="field">
          <label>Reason</label>
          <PickerDropdown
            align="left"
            value={value.reason || ''}
            onPick={(reason) => onChange({ reason })}
            placeholder="Not given"
            options={[{ value: '', label: 'Not given' }, ...TIME_OFF_REASONS.map((r) => ({ value: r.key, label: r.label }))]}
          />
        </div>
        <div className="field">
          <label>Time-off request</label>
          <PickerDropdown
            align="left"
            value={value.requestStatus || ''}
            onPick={(requestStatus) => onChange({ requestStatus })}
            placeholder="Not tracked"
            options={[
              { value: '', label: 'Not tracked' },
              ...REQUEST_STATUSES.map((r) => ({ value: r.key, label: r.short })),
            ]}
          />
        </div>
      </div>
      <div className="field">
        <label htmlFor={`${idPrefix}-internal`}>Internal note <span className="hint">optional</span></label>
        <textarea
          id={`${idPrefix}-internal`}
          rows={2}
          maxLength={2000}
          value={value.internalNote}
          placeholder="Called in at 6:40, doctor’s note to follow."
          onChange={(e) => onChange({ internalNote: e.target.value })}
        />
      </div>
    </fieldset>
  )
}

/** The dialog's state from a row being edited, or empty for a new one. */
export const privateFrom = (t) => ({
  reason: t?.reason || '',
  requestStatus: t?.requestStatus || '',
  internalNote: t?.internalNote || '',
})

/** What goes on the wire: blanks as null, and the note sent even when emptied so it clears. */
export const privateBody = (v) => ({
  reason: v.reason || null,
  requestStatus: v.requestStatus || null,
  internalNote: v.internalNote.trim(),
})
